import { Component, OnInit, ViewChild } from '@angular/core';
import { MassCommService, Message, MessageQueueSearch } from '../../shared/index';
import { Router } from '@angular/router';
import { Table as PrimeDataTable } from 'primeng/table';
import { NotificationService, PagedResultGeneric, UtilService } from '../../../shared/index';
import { TranslationService } from '../../../shared/translation/translation.service';
import { PagedResult } from '../../../shared/model/generic-paged-result.model';
import { DatagridService } from '../../../shared/index';
import { debounce } from 'lodash-decorators';
import { LazySelectableTableComponent } from 'src/app/shared/primeng/abstract-classes/lazy-selectable-table.component';

/**
 * admin mass comm scheduled message
 */
@Component({
  selector: 'wl-mass-comm-message-admin-sent-messages',
  templateUrl: 'mass-comm-message-admin-sent-messages.component.html',
  styleUrls: [],
  providers: [],
    standalone: false
})
export class MassCommMessageAdminSentMessagesComponent
  extends LazySelectableTableComponent<MessageQueueSearch, Message>
  implements OnInit {
  @ViewChild('sentGrid', { static: false }) private _sentGrid: PrimeDataTable;

  public isBusy: boolean = false;
  public deleting: boolean = false;
  public isSearching: boolean = false;
  public sentResult: PagedResult<Array<Message>> = new PagedResult<Array<Message>>([]);
  private _messageToDelete: Message;
  public showModal = false;
  public localTimeZoneAbbreviation: string;

  /**
   * inject
   * @param _massCommService
   */
  public constructor(
    private _massCommService: MassCommService,
    private _notificationService: NotificationService,
    private _translationService: TranslationService,
    private _router: Router,

    public datagridService: DatagridService,
    private _utilService: UtilService
  ) {
    super("MessageId", datagridService);
    this.searchParams = new MessageQueueSearch();
  }

  fetchResults(): Promise<PagedResultGeneric<Message>> {
    return this._massCommService.search(this.searchParams);
  }

  @debounce(500)
  filterChanged() {
    this.searchParams.PageNumber = 1;
    this.getSentMessages();
  }

  /**
   * on init
   */
  public ngOnInit(): void {
   this.localTimeZoneAbbreviation = this._utilService.getLocalTimeZoneAbbreviation();
  }

  /**
   * start a search
   */
  public startSearch(): void {
    let oldSortField: string = this._sentGrid.sortField;
    let oldSortOrder: number = this._sentGrid.sortOrder;

    this._sentGrid.reset();

    this._sentGrid.sortField = oldSortField;
    this._sentGrid.sortOrder = oldSortOrder;
  }

  /**
   * for the ngprime data table
   */
  public lazyLoadSentMessages($event: any): void {
    this.datagridService.mapDatagridPagingToPagedSearch($event, this.searchParams);

    if (!this.isSearching) this.getSentMessages();
  }

  public getSentMessages() {
    if (this.isSearching) return;

    this.isSearching = true;
    this.searchParams.MessageSent = true;

    this.fetchResults().then(
      (result: PagedResult<Array<Message>>) => {
        this.datagridService.mapPagedResultsToPagedSearch(result, this.searchParams);
        this.sentResult = result;
        this.isSearching = false;
      },
      () => {
        this.isSearching = false;
      }
    );
  }

  /**
   * copy a given message
   */
  public copyMessage(message: Message): void {
    if (this.isBusy || !message) return;

    this._router.navigate(['communications/message/copy', message.MessageId]);
  }

  /**
   * prompt before deleting
   */
  public confirmDeleteMessage(message: Message): void {
    if (this.deleting || !message || !message.MessageId) return;

    this._messageToDelete = message;

    this.showModal = true;
  }

  /**
   * delete a given message
   */
  public deleteMessgeConfirmed(): void {
    if (this.deleting || !this._messageToDelete) return;

    this.deleting = true;

    this._massCommService.deleteMessage(this._messageToDelete.MessageId).then(
      () => {
        this.deleting = false;

        this._translationService.getTitlecase('communications.mass-comm-message-admin.message-deleted').then((message: string) => {
          this._notificationService.success(message);
        });

        this.showModal = false;

        this.getSentMessages();
      },
      () => {
        this.deleting = false;
      }
    );
  }
}
